import { API_LCL_URL, LOCAL_STORAGE } from 'app/commons/constants'
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import i18n from 'i18next'

import { deleteAllStorage } from '..'

const serializeQuery: any = (params: any, prefix: any) => {
  const query = Object.keys(params).map((key) => {
    const value = params[key]

    if (params.constructor === Array) key = `${prefix}[]`
    else if (params.constructor === Object) key = prefix ? `${prefix}[${key}]` : key

    if (value === null || value === undefined) return `${key}=`
    else if (typeof value === 'object') return serializeQuery(value, key)
    else return `${key}=${encodeURIComponent(value)}`
  })

  return [].concat(...query).join('&')
}

const apiClient = axios.create({
  baseURL: API_LCL_URL,
  headers: {
    'Content-Type': 'application/json',
    'Device-Type': 'Webapp',
    'Accept-Language': i18n.language,
    'x-product-line': 'lcl',
  },
  paramsSerializer: (params: any) => serializeQuery(params),
})

apiClient.interceptors.request.use((config: AxiosRequestConfig) => {
  const token = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)
  const CountryCode = 'id'
  return {
    ...config,
    headers: {
      ...{ countrycode: CountryCode },
      ...(token ? { Authorization: token } : {}),
      ...config.headers,
    },
  }
})

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  async (error: AxiosError<any>) => {
    if (error.response) {
      if (error.response.status === 401) {
        deleteAllStorage()
        window.location.replace('/')
      }
      if (typeof error.response.data === 'string' || error.response.data instanceof String)
        return { error: error.response.data, status: error.response.status }

      return { ...error.response.data, status: error.response.status }
    }

    return error?.response || error
  }
)
export default apiClient
